import { render } from "./ai-grid-virtual-footer.vue?vue&type=template&id=3ac4ab96&scoped=true"
import script from "./ai-grid-virtual-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-virtual-footer.vue?vue&type=script&setup=true&lang=js"

import "./ai-grid-virtual-footer.vue?vue&type=style&index=0&id=3ac4ab96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac4ab96"],['__file',"src/components/ai-grid-virtual/ai-grid-virtual-footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac4ab96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac4ab96', __exports__)) {
    api.reload('3ac4ab96', __exports__)
  }
  
  module.hot.accept("./ai-grid-virtual-footer.vue?vue&type=template&id=3ac4ab96&scoped=true", () => {
    api.rerender('3ac4ab96', render)
  })

}


export default __exports__